<div class="box box-info">
  <div class="box-header with-border">
    <h3 class="box-title">Assign staff</h3>
  </div>
  <!-- /.box-header -->
  <!-- form start -->
  <form class="form-horizontal" role="form" [formGroup]="form" novalidate>
    <div class="box-body">
      <div class="form-group">
        <label for="inputPassword3" class="col-sm-3 control-label">Staff</label>

        <div class="col-sm-9">
          @if (staffs) {
            <select
              class="form-control is-invalid"
              formControlName="user"
              >
              <option value="">Select a staff member</option>
              @for (manager of staffs.managers; track manager) {
                <option
                  value="{{ manager.id }}"
                  >{{ manager.first_name }} {{ manager.last_name }} -
                  Manager</option
                  >
                }
                @for (supervisor of staffs.supervisors; track supervisor) {
                  <option
                    value="{{ supervisor.id }}"
                    >{{ supervisor.first_name }} {{ supervisor.last_name }} -
                    Supervisor</option
                    >
                  }
                </select>
              }
              @if (
                form.controls['user'].hasError('required') &&
                (form.controls['user'].touched || attemptedSubmit)
                ) {
                <control-message
                  message="Staff is required."
                ></control-message>
              }
            </div>
          </div>
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          <div class="box-footer">
            <button
              type="button"
              (click)="submitForm()"
              class="btn btn-info pull-right"
              >
              Submit
            </button>
          </div>
        </div>
        <!-- /.box-footer -->
      </form>
    </div>
